<template>
  <div>
    <headers>
      <div class="header-main">
        <h1>{{ $t("content.header.h1") }}</h1>
        <h2>{{ $t("content.header.h2") }}</h2>
        <p>
          <img src="../assets/icon/content-address.svg" alt />
          <span>{{ $t("content.header.p1") }}</span>
        </p>
        <p>
          <img src="../assets/icon/content-email.svg" alt />
          <span>{{ $t("content.header.p2") }}</span>
        </p>
        <p>
          <img src="../assets/icon/content-phone.svg" alt />
          <span>{{ $t("content.header.p3") }}</span>
        </p>
      </div>
    </headers>
    <section class="main container">
      <div class="main-join">
        <h1>{{ $t("content.main.main-join.h1") }}</h1>
        <h2>{{ $t("content.main.main-join.h2") }}</h2>
        <p>{{ $t("content.main.main-join.p1") }}</p>
        <p>{{ $t("content.main.main-join.p2") }}</p>
        <p>{{ $t("content.main.main-join.p3") }}</p>
        <router-link class="todetail-btn" to="/content/join">{{ $t("content.main.main-join.btn") }}</router-link>
      </div>
      <div class="main-Cooperation">
        <h1>{{ $t("content.main.main-Cooperation.h1") }}</h1>
        <ul>
          <li>
            <h3>{{ $t("content.main.main-Cooperation.li1.title") }}</h3>
            <p>{{ $t("content.main.main-Cooperation.li1.p1") }}</p>
            <p>{{ $t("content.main.main-Cooperation.li1.p2") }}</p>
          </li>
          <li>
            <h3>{{ $t("content.main.main-Cooperation.li2.title") }}</h3>
            <p>{{ $t("content.main.main-Cooperation.li2.p1") }}</p>
            <p>{{ $t("content.main.main-Cooperation.li2.p2") }}</p>
          </li>
          <li>
            <h3>{{ $t("content.main.main-Cooperation.li3.title") }}</h3>
            <p>{{ $t("content.main.main-Cooperation.li3.p1") }}</p>
            <p>{{ $t("content.main.main-Cooperation.li3.p2") }}</p>
          </li>
          <li>
            <h3>{{ $t("content.main.main-Cooperation.li3.title") }}</h3>
            <p>{{ $t("content.main.main-Cooperation.li4.p1") }}</p>
            <p>{{ $t("content.main.main-Cooperation.li4.p2") }}</p>
          </li>
        </ul>
      </div>
    </section>
    <footers></footers>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.bg {
  background-image: url(https://static3.freshin.online/sku/Fre-3wSY-KbF7806lUx-cg%2BeBvY%3D);
}
.header-main {
  display: flex;
  margin-top: 5.88rem;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
}
.header-main h1 {
  font-weight: normal;
  font-size: 3rem;
  margin-bottom: 3.5rem;
}
.header-main h2 {
  font-size: 1.88rem;
  font-weight: normal;
  margin-bottom: 1.5rem;
}
.header-main p {
  margin: 1rem 0;
}
.header-main span {
  font-size: 1.25rem;
  font-weight: 300;
}
.header-main img {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: text-top;
}
.main-join {
  border-bottom: 1px solid rgba(202, 202, 202, 1);
  color: #000000;
  padding: 9.12rem 0;
}
.main-join > h1 {
  font-size: 3rem;
  font-weight: 400;
  margin-bottom: 3.5rem;
}
.main-join > h2 {
  font-size: 1.88rem;
  font-weight: 400;
  margin-bottom: 1rem;
}
.main-join > p {
  color: rgba(102, 102, 102, 1);
  font-size: 1.25rem;
  font-weight: 300;
  margin: 2rem 0;
}
.main-join .todetail-btn {
  height: 2rem;
  width: 10rem;
  position: relative;
  /* border: 1px solid #1890ff; */
  /* box-shadow: inset -1px 1px 1px 1px #1890ff; */
  border-radius: 5px;
  display: block;
  text-align: center;
  line-height: 2rem;
  color: #1890ff;
  text-decoration: none;
}
.main-join .todetail-btn::after {
    content: '';
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #1890ff;
    border-radius: 5px;
    -webkit-transform: scale(0.5,0.5);
    transform: scale(0.5,0.5);
    -webkit-transform-origin: top left;
}

.main-Cooperation {
  padding: 6rem 0;
  padding-bottom: 10rem
}
.main-Cooperation > h1 {
  font-weight: 400;
  font-size: 3rem;
  margin-bottom: 4rem;
}
.main-Cooperation > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.main-Cooperation > ul > li {
  /* margin-right: 5rem; */
  margin-bottom: 2rem;
}
.main-Cooperation > ul > li:last-child {
  margin-right: 0;
}
.main-Cooperation > ul > li > h3 {
  font-size: 1.25rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
}
.main-Cooperation > ul > li > p {
  font-size: 0.88rem;
  font-weight: 300;
  margin-bottom: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// content.vue?0c063652